module.exports = __webpack_public_path__ + "static/media/pill.c6f9ff18.svg";